import React, { useState } from 'react';
import RadiusInput from 'components/common/formElements/radiusInput';
import PswPopOver from 'components/common/helpers/passwordHelper';
import Form from 'components/common/formElements/form';
import buttons from 'style/buttons.module.scss';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
import styles from './index.module.scss';

interface IProps {
  currentEmail?: string;
}

type PasswordData = {
  password: string;
  passwordConfirm: string;
};

const ChangePassword: React.FC<IProps> = () => {
  const [password, setPassword] = useState('');

  const schema = yup.object().shape({
    currentPassword: yup.string().required(),
    password: yup
      .string()
      .min(8)
      .max(64)
      .matches(/^(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)[a-zA-Z\d]{8,64}$/)
      .required('Password is required'),
    passwordConfirm: yup
      .string()
      .oneOf([yup.ref('password'), null])
      .required(),
  });
  const { register, handleSubmit, errors } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = (values: PasswordData) => {
    // eslint-disable-next-line no-console
    console.log(values);
    // const requestData = {
    //   newPassword: values.password,
    // };
    // dispatch(resetPassword(requestData));
  };
  return (
    <>
      <div className={styles.changeField}>
        <div className={styles.header}>
          <span>Password</span>
          <p>You can change your Password</p>
        </div>
        <div className={styles.inputBlock}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <RadiusInput
              variant="outlined"
              type="text"
              label="Current Password"
              name="currentPassword"
              ref={register}
              error={!!errors.currentPassword}
            />
            <RadiusInput
              variant="outlined"
              id="password"
              type="password"
              label="New password"
              name="password"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPassword(e.target.value)
              }
              ref={register}
              error={!!errors.password}
            />
            <PswPopOver password={password} target="password" />
            <RadiusInput
              variant="outlined"
              type="password"
              label="Repeat New Password"
              name="passwordConfirm"
              ref={register}
              error={!!errors.passwordConfirm}
            />
            <button type="submit" className={buttons.buttonBlue}>
              Save Changes
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};
export default ChangePassword;
